import dayjs from 'dayjs';

const humanizeDate = (date: Date | string) => dayjs(date).format('DD/MM/YYYY');

export default humanizeDate;
